import React from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Alert, Button, Col, Form, Modal, Radio, Row } from 'antd'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'

const TERMINAL_STATUSES = ['CANCEL', 'DONE']

const RedeemTransactionForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form
  const isTerminal = TERMINAL_STATUSES.includes(formData.status)
  // คูปองแลกแล้วจบ ยกเลิกไม่ได้ คืนพอยท์ไม่ได้ (BR-14b)
  // ซ่อนปุ่มเป็นแค่ด่านแรก backend ปฏิเสธซ้ำอีกชั้นอยู่แล้ว
  const isCoupon = formData.rewardType === 'COUPON'

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        status: formData.status
      })
    }

    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    if (isTerminal) return
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          status: values.status,
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }
  return (
    <Modal
      title='Update Status'
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      {isCoupon && !isTerminal && (
        <Alert
          message="ยกเลิกคูปองไม่ได้"
          description="คูปองแลกแล้วไม่คืนพอยท์ทุกกรณี รวมถึงกรณีที่ผู้ใช้ไม่ได้ใช้จนหมดอายุ"
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      {isTerminal && (
        <Alert
          message="ไม่สามารถเปลี่ยนสถานะได้"
          description={`สถานะปัจจุบันเป็น ${formData.status === 'CANCEL' ? 'ยกเลิก' : 'จัดส่งเรียบร้อย'} แล้ว ไม่สามารถเปลี่ยนแปลงได้อีก`}
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="Status">
          {getFieldDecorator(`status`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group disabled={isTerminal}>
              <Radio value='DONE'>จัดส่งเรียบร้อย</Radio>
              <Radio value='WAITING'>อยู่ในระหว่างการจัดส่ง</Radio>
              <Radio value='CANCEL' disabled={isCoupon}>
                ยกเลิก
              </Radio>
            </Radio.Group>
          )}
        </Form.Item>
        {Array.isArray(formData.allocations) && formData.allocations.length > 0 && (
          <Form.Item label="ตัดพอยท์จากกระเป๋า">
            {formData.allocations.map((allocation, index) => (
              <div key={index}>
                {allocation.scopeName} — {allocation.amount} พอยท์
              </div>
            ))}
          </Form.Item>
        )}
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx
              color={isTerminal ? '#d9d9d9' : '#6ebf4b'}
              type="primary"
              htmlType="submit"
              disabled={isTerminal}>
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

RedeemTransactionForm.propTypes = {
  form: PropTypes.any,
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedRedeemTransactionForm = Form.create({ name: 'RedeemTransactionForm' })(
  RedeemTransactionForm
)
export default WrappedRedeemTransactionForm
